export default (registerData) => {
  return {
    event: 'registerFailCP',
    position: 'Modal',
    Flujo: 'MYB',
    storefront: registerData.storefront, // Dynamic Data
  };
};